import { useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnFilterClickTransfer(props) {
  let current = useDataValue({
    context: 'tab',
    path: 'selected.ledger.transactions.filter_by',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'tab',
    path: 'selected.ledger.transactions.filter_by',
    viewPath: props.viewPath,
  })

  return function onClick() {
    if (current.length === 0) {
      change(['transfer'])
      return
    }

    if (current.includes('transfer')) {
      let newSelected = current.filter(item => item !== 'transfer')
      change(newSelected)
    } else {
      change([...current, 'transfer'])
    }
  }
}

export function getCount(transactions, type) {
  return transactions.filter(item => item.type === type).length
}
